<ng-container *ngIf="{ value: (fullItemAccess$ | async) ?? false } as fullItemAccess">
  <div class="invoice-items-list" *ngIf="!mobileView" [class.disabled]="readonly">

    <div *ngIf="invoiceVersion" cdkDropList (cdkDropListDropped)="dropAction($event)" class="items-list">
      <div *ngFor="let invoiceItem of invoiceVersion.items; let i = index"
           class="invoice-items-list-item" cdkDrag
           (cdkDragStarted)="dragging = true"
           (cdkDragEnded)="dragging = false"
           (click)="readonly ? null : editItem(invoiceItem, fullItemAccess.value)"
           [cdkDragDisabled]="readonly"
      >
        <div class="invoice-item-left flex-fill"
             (mouseenter)="itemPrice.classList.add('primary-dark-color')"
             (mouseleave)="itemPrice.classList.remove('primary-dark-color')"
             #invoiceItemLeft
        >
          <app-icon class="clickable hide" src="6dots" cdkDragHandle
                    [class.hide]="(invoiceVersion.items ?? []).length < 2"
                    [class.disabled-semitransparent]="readonly"
                    (click)="$event.stopPropagation()"
          ></app-icon>
          <div class="item-index" [class.two-char]="i>=9" [style.opacity]="dragging ? '0' : '100'">{{i+1}}</div>
          <div class="item-name" [class.two-char]="i>=9">{{invoiceItem.name}}</div>
        </div>
        <div class="invoice-item-right">
          <div class="item-qty-price" [id]="'qty-price-'+i" (click)="$event.stopPropagation()">
            <div class="item-qty">
              <h4 class="item-qty-text">Qty</h4>
              <mat-form-field appearance="outline" class="width--38 height--24"
                (click)="$event.stopPropagation()"
                [class.disabled]="readonly"
                [class.filled]="readonly"
              >
                <input matInput style="bottom: 8px"
                       maxlength="4"
                       [defaultValue]="invoiceItem.quantity"
                       (input)="qtyFieldInput($event, invoiceItem, false, 'qty-price-'+i)"
                       (focusout)="qtyFocus$.next(false)"
                       (focus)="qtyFocus$.next(true)"
                       [id]="'qty-input'+i"
                       autocomplete="off"
                       class="tac fw-600 position-relative"
                       inputmode="numeric"
                       (keydown)="digitsOnly($event)"
                       (paste)="onPaste($event)"
                       ondrop="return false;"
                       [readonly]="readonly"
                >
              </mat-form-field>
            </div>
            <div class="item-price" (click)="editItem(invoiceItem, fullItemAccess.value)"
                 (mouseenter)="invoiceItemLeft.classList.add('primary-dark-color')"
                 (mouseleave)="invoiceItemLeft.classList.remove('primary-dark-color')"
            >
              <h4 class="w-100 tar" #itemPrice>
                ${{(+getItemPrice(invoiceItem)).toFixed(2)}}
              </h4>
            </div>
          </div>
          <div class="item-info-edit" (click)="$event.stopPropagation()">
            <app-workflow-item-info [eoIItem]="invoiceItem"
                                    [hoveredItemIndex]="hoveredItemIndex"
                                    [index]="i"
                                    *ngIf="infoIconDistancesFromTop.length > 0"
                                    [distanceFromTop]="infoIconDistancesFromTop[i]"
                                    [salesTaxPercentage]="invoiceVersion.clientSalesTaxPercentage!"
                                    [businessId]="(businessId$ | async)!"
            ></app-workflow-item-info>
            <app-icon class="item-info-icon" src="item-info"
                      (mouseenter)="hoveredItemIndex = i"
                      (mouseleave)="hoveredItemIndex = null"
                      [id]="'info-icon-'+i"
                      [style.pointer-events]="'auto'"
            ></app-icon>
            <app-icon class="clickable dots3-icon" src="3dots"
                      [matMenuTriggerFor]="readonly ? null :itemActionsMenu"
                      [matMenuTriggerData]="{ item: invoiceItem, index: i }"
                      [class.disabled-semitransparent]="readonly"
            ></app-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="add-invoice-item"
         [class.no-items]="(invoiceVersion.items ?? []).length === 0"
         [class.disabled-semitransparent]="!invoiceVersion.clientSalesTaxPercentage || readonly"
         (click)="invoiceVersion.clientSalesTaxPercentage && !readonly ? openAddInvoiceItemModal(fullItemAccess.value) : null"
    >
      <app-icon class="se-icon-button" [class.no-hover]="!invoiceVersion.clientSalesTaxPercentage" src="plus"></app-icon>
      <p class="add-invoice-item-button-text">Item</p>
    </div>

    <app-invoice-summary *ngIf="(invoiceVersion.items ?? []).length > 0"
                         [invoice]="invoice" [invoiceVersion]="invoiceVersion"
                         [readonly]="readonly"
    ></app-invoice-summary>

  </div>

  <div class="invoice-items-list-mobile" *ngIf="mobileView" [class.disabled]="readonly">

    <div *ngIf="(invoiceVersion.items ?? []).length > 0" class="invoice-items-mobile">
      <div *ngFor="let invoiceItem of invoiceVersion.items let i = index"
           class="invoice-item-mobile"
      >

        <div class="invoice-item-mobile-top" (click)="editItem(invoiceItem, fullItemAccess.value)">
          <div class="name">{{invoiceItem.name}}</div>
          <div class="actions" (click)="$event.stopPropagation()">
            <app-icon class="dots3-icon" src="3dots" [matMenuTriggerFor]="readonly ? null : itemActionsMenu"
                      [matMenuTriggerData]="{ item: invoiceItem, index: i }"
                      [class.disabled-semitransparent]="readonly"
            ></app-icon>
            <app-icon class="item-info-icon" src="item-info" (click)="openItemInfoMobile(invoiceItem)"></app-icon>
          </div>
        </div>

        <div class="divider"></div>
        <div class="invoice-item-mobile-bottom" (click)="editItem(invoiceItem, fullItemAccess.value)">
          <div class="qty-block">
            <div class="label">Qty</div>
            <mat-form-field appearance="outline" class="width--38 height--24" (click)="$event.stopPropagation()">
              <input matInput style="bottom: 8px"
                     maxlength="4"
                     [defaultValue]="invoiceItem.quantity"
                     (focusout)="qtyFocus$.next(false)"
                     (focus)="qtyFocus$.next(true)"
                     (input)="qtyFieldInput($event, invoiceItem, true)"
                     autocomplete="off"
                     class="tac fw-600 position-relative"
                     inputmode="numeric"
                     (keydown)="digitsOnly($event)"
                     (paste)="onPaste($event)"
                     ondrop="return false;"
                     [readonly]="readonly"
              >
            </mat-form-field>
          </div>
          <div class="total d-flex">
            <div>$</div>
            <div class="fw-600">{{(+getItemPrice(invoiceItem)).toFixed(2)}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="add-invoice-item"
         [class.no-items]="(invoiceVersion.items ?? []).length === 0"
         [class.disabled-semitransparent]="!invoiceVersion.clientSalesTaxPercentage || readonly"
         (click)="invoiceVersion.clientSalesTaxPercentage && !readonly ? openAddInvoiceItemModal(fullItemAccess.value) : null"
    >
      <app-icon class="se-icon-button" [class.no-hover]="!invoiceVersion.clientSalesTaxPercentage" src="plus"></app-icon>
      <p class="add-invoice-item-button-text">Item</p>
    </div>

    <app-invoice-summary *ngIf="(invoiceVersion.items ?? []).length > 0"
                         [invoice]="invoice" [invoiceVersion]="invoiceVersion"
                         [readonly]="readonly"
    ></app-invoice-summary>
  </div>

  <mat-menu #itemActionsMenu xPosition="before" class="no-margin">
    <ng-template matMenuContent let-item="item" let-index="index">
      <mat-option (click)="editItem(item, fullItemAccess.value)">Edit</mat-option>
      <mat-option (click)="duplicateItem(item, index)">Duplicate</mat-option>
      <mat-option (click)="deleteItem(index)">Delete</mat-option>
    </ng-template>
  </mat-menu>

</ng-container>
